import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

type PromptEditorProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  style?: React.CSSProperties;
  multiline?: boolean;
};

const MERGE_TAGS: { key: string; label: string; tag: string }[] = [
  { key: 'stateName', label: 'State name', tag: '{stateName}' },
  { key: 'districtName', label: 'District', tag: '{districtName}' },
  { key: 'electionName', label: 'Election', tag: '{electionName}' },
  { key: 'startingUrl', label: 'Starting URL', tag: '{startingUrl}' },
];

const PromptEditor: React.FC<PromptEditorProps> = ({
  label,
  value,
  onChange,
  placeholder,
  disabled,
  rows = 4,
  style = {},
  multiline = true,
}) => {
  const handleInsertTag = (tag: string) => {
    if (disabled) return;
    const insert = value ? `${value}${value.endsWith(' ') ? '' : ' '}${tag}` : tag;
    onChange(insert);
  };

  return (
    <Box display="flex" flexDirection="column" style={style}>
      {label && (
        <Typography variant="body1" color="textPrimary" sx={{ fontWeight: 600 }}>
          {label}
        </Typography>
      )}
      <Box
        display="flex"
        style={{
          justifyContent: 'flex-end',
        }}
        flexWrap="wrap"
        gap={1}
        mb={0.5}
      >
        {MERGE_TAGS.map((tag) => (
          <Button
            key={tag.key}
            variant="outlined"
            size="small"
            onClick={() => handleInsertTag(tag.tag)}
            disabled={disabled}
          >
            <Typography variant="body2" style={{ fontFamily: 'monospace', textTransform: 'none' }}>
              {tag.label}
            </Typography>
          </Button>
        ))}
      </Box>
      <TextField
        multiline={multiline}
        fullWidth
        {...(multiline ? { minRows: rows, maxRows: rows } : {})}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Box>
  );
};

export default PromptEditor;

